import { Button, Box, Card, CardActions, CardContent, Container, Link as MuiLink, Typography } from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';
import { HELP_URL } from "../../constants";
import { Link } from "react-router-dom";

export default function CheckoutError() {
  return (
    <Container sx={{ p: 3 }} maxWidth="md">
      <Card>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center' }}>
            <WarningIcon sx={{ fontSize: 72 }} color="error" />
          </Box>
          <Typography sx={{ textAlign: 'center', mt: 2 }} variant="h3">
            Something Went Wrong
          </Typography>
          <Typography sx={{ textAlign: 'center', mt: 2 }}>
            There was an issue during the checkout process. Your subscription could not been started. Please <MuiLink href={HELP_URL} target="_blank">contact support</MuiLink> if this issue persists.
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'center' }}>
          <Button href={HELP_URL} target="_blank" variant="outlined">Contact Support</Button>
          <Button component={Link} to="/account" variant="outlined">Back to Account</Button>
        </CardActions>
      </Card>
    </Container>
  );
}